export const colors = [
  '#7166d9',
  '#59b950',
  '#c891db',
  '#bf55c4',
  '#a0b433',
  '#d79c33',
  '#5b72bc',
  '#da6b2f',
  '#62a0d8',
  '#d24038',
  '#3dbbb8',
  '#df3d71',
  '#5cb481',
  '#cd4a97',
  '#507d36',
  '#8e559e',
  '#baae66',
  '#994666',
  '#86702d',
  '#de83a1',
  '#a45631',
  '#c04d5b',
  '#e48f6e',
];
